import React, { Fragment } from 'react';
import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';

interface PaymentPopupProps {
  show: boolean;
  message: string;
  type: 'success' | 'cancel' | null;
}

// Simple, readable icons
const SuccessIcon: React.FC = () => (
  <svg viewBox="0 0 24 24" className="pp-toast-icon-svg" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M5 13l4 4L19 7" />
  </svg>
);

const CancelIcon: React.FC = () => (
  <svg viewBox="0 0 24 24" className="pp-toast-icon-svg" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <line x1="6" y1="6" x2="18" y2="18" />
    <line x1="6" y1="18" x2="18" y2="6" />
  </svg>
);

const PaymentPopup: React.FC<PaymentPopupProps> = ({ show, message, type }) => {
  if (!type) return null;

  const isSuccess = type === 'success';
  const wrapColors = isSuccess
    ? 'bg-green-50 text-green-800 ring-green-200'
    : 'bg-red-50 text-red-800 ring-red-200';
  const iconColors = isSuccess
    ? 'bg-green-100 text-green-600'
    : 'bg-red-100 text-red-600';

  return (
    <Transition show={show} as={Fragment}>
      <Dialog as="div" className="fixed inset-0 z-50 pointer-events-none" onClose={() => {}}>
        <div className="pp-toast-wrap">
          <TransitionChild
            as={Fragment}
            enter="ui-pop-enter"
            enterFrom="ui-pop-enter-from"
            enterTo="ui-pop-enter-to"
            leave="ui-pop-leave"
            leaveFrom="ui-pop-leave-from"
            leaveTo="ui-pop-leave-to"
          >
            <DialogPanel
              role="status"
              aria-live="polite"
              className={`pp-toast-panel ${wrapColors}`}
              // widen the panel so text fits on one line
              style={{ maxWidth: 640, width: 'max-content' }}
            >
              <span className={`pp-toast-icon ${iconColors}`}>
                {isSuccess ? <SuccessIcon /> : <CancelIcon />}
              </span>
              <div className="pp-toast-text whitespace-nowrap">{message}</div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  );
};

export default PaymentPopup;